import ProductModal from '../components/ProductModal'
import ThreeSixty from '../components/ThreeSixty'

import log from 'salvo-lite/log'

class Product {
    constructor (components) {
        this._name = this.constructor.name
        this.components = components
        this.howToUseVideoPlayer = this.components.getComponentsById('howToUseVideoPlayer')
    }

    onInit () {
        log.debug(this._name, 'Initiated', this)
        this.productSlider(this.components.getComponentsById('productImageSlider'))
        if (this.components.getComponentsById('mayAlsoLikeSlider')) {
            this.mayAlsoLike(this.components.getComponentsById('mayAlsoLikeSlider'))
        }
        if (this.components.getComponentsById('recentlyViewed')) {
            this.recentlyViewed(this.components.getComponentsById('recentlyViewed'))
        }
        if (this.components.getComponentsById('resultSlider')) {
            this.components.getComponentsById('resultSlider').init()
        }
        if (this.howToUseVideoPlayer) {
            this._resultsVideo()
        }
    }

    _resultsVideo () {
        document.addEventListener('tab-changed', e => {
            log.debug(this._name, 'Tab Changed!', e)
            if (e.tabs.activeHandle === 'how-to-use') {
                this.howToUseVideoPlayer.playVideo(true)
                return true
            }
            this.howToUseVideoPlayer.pauseVideo()
        })
    }

    productSlider (productSlider) {
        productSlider._elem.addEventListener('initiated', e => {
            this.addThreeSixty(productSlider._slides)
        })
        productSlider.init()
        productSlider._elem.addEventListener('after-slide', e => {
            if (productSlider.activeSlide.threeSixty) {
                productSlider.activeSlide.threeSixty.fullSpin()
            }
        })
    }

    addThreeSixty (slides) {
        for (let slide of slides) {
            let threeSixtyViewer = slide.querySelector('[data-three-sixty]')
            if (!threeSixtyViewer) continue
            slide.threeSixty = new ThreeSixty(window.__Theme, threeSixtyViewer)
            slide.threeSixty.init()
        }
    }

    recentlyViewed (recentlyViewed) {
        recentlyViewed._elem.addEventListener('rendered', (e) => {
            if (this.components.getComponentsById('recentlyViewedSlider')) {
                let sliderComp = this.components.getComponentsById('recentlyViewedSlider')
                sliderComp._elem.addEventListener('initiated', e => {
                    this.addProductModal(sliderComp._slides)
                })
                sliderComp.init()
            }
        })
        recentlyViewed.init()
    }

    mayAlsoLike (sliderComp) {
        sliderComp._elem.addEventListener('initiated', e => {
            this.addProductModal(sliderComp._slides)
        })
        sliderComp.init()
    }

    addProductModal (slides) {
        for (let slide of slides) {
            if (slide.productModal) continue
            slide.productModal = new ProductModal(window.__theme, slide)
            slide.productModal.onInit()
        }
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/scripts/pages/Product.js